"use client";
import React, { useEffect } from "react";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import AnimatedQuantityButton from "../QuantityButton";
import FavoriteButton from "../FavoriteButton";
import { Checkbox } from "@dxp-feed/ui/Checkbox";
import ImageWrapper from "@/components/ImageWrapper";

import {
  analyticsAddToCartEventAfterSearch,
  analyticsAddToCartEventBeforeSearch,
  analyticsClickEventAfterSearch,
  analyticsClickEventBeforeSearch,
} from "@/services/algolia/analytics";
import { ALGOLIA_INDEXES, algoliaConfig } from "@/services/algolia/config";
import {
  useAppSelector,
  useAppDispatch,
  useState,
  useCallback,
  useRef,
} from "@/utils/hooks/reactUseCustomHooks";
import { HighlightText } from "../Header/Search/HighlightText";
import {
  deleteFavouriteProduct,
  setItemListData,
  setShoppingMessage,
  setSubstituteListData,
  subtituteProductFromShopList,
} from "@/utils/redux/shoppingList";
import {
  dataLayerRemoveFormList,
  addDataLayerProductToList,
  addDataLayerProductToFavourite,
  dataLayerProductSelectList,
} from "@/helpers/dataLayer";
import { sendSalesforceInteraction } from "@/helpers/cdnSdk";
import { getUTMParameter } from "@/helpers/getUTMParameters";
import {
  ShoppingListItem,
  SubstituteProductProduct,
} from "@/utils/types/manageList";
import {
  addListItemsToCart,
  substituteShopItem,
} from "@/utils/redux/shoppingList/actions";
import ProductLoginModal from "@/components/ProductLoginModal";
import { Product } from "@/utils/types/product";
import { addItemToFavouriteList } from "@/utils/redux/favouriteProduct/actions";
import { truncateString } from "@/helpers/global";
import {
  setCartItemListData,
  subtituteProductFromCartList,
  updateCartShoppingList,
} from "@/utils/redux/cartProduct";
import {
  CheckIfRecordIsPreferred,
  CheckValidProductImage,
  useDelayedCallback,
} from "@/helpers/useCommonFunctions";
import { usePathname, useRouter } from "next/navigation";
import PromotionsHeader from "../PromotionsHeader";
import { promotionMapping } from "@/utils/promotions";
import { CustomToast } from "../CustomToast";
import GroupOffers from "@/templates/offers/GroupOffers/GroupOffers";
import { searchBySingleIndex } from "@/services/algolia";
import { useGigya } from "@dxp-feed/gigya";
//import { fetchAlgoliaProduct } from "@/helpers/shoppingListHelper";
import { Button } from "@dxp-feed/ui";
import {
  fetchAlgoliaProduct,
  showPromotions,
} from "@/helpers/shoppingListHelper";
import { useStoreDetails } from "@/utils/hooks/useStoreDetails";
import {
  NO_ALCOHOL_STORES,
  PromotionKeys,
  TPromotionKeys,
} from "@/utils/constant";
import OfferCardBadge from "../Common/OfferCardBadge";
import { useGigyaAccountInfo } from "@/helpers/gigyaCentralSsoHook";
import Link from "@/components/Link";
import { addOrUpdateProductAndRefreshExisting } from "@/lib/indexedDb/product";
import SplitAmount from "@/utils/offers/SplitAmount";
import { AemSearchDropDown } from "@/utils/types/aem";
import { setFavouriteMessage } from "@/utils/redux/favouriteProduct";

interface OfferCardProps {
  item?: any;
  isSearchPage?: boolean;
  isGlobalSearch?: boolean;
  isShopped?: boolean;
  showFavoriteButton?: boolean;
  showAddToCartButton?: boolean;
  query?: string;
  checked?: boolean;
  onCheckboxClick?: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  checkBoxClass?: string;
  listId?: number;
  onVisibilityChange?: (items: object, isVisible: boolean) => void;
  observerAffilation?: string;
  pageId?: number;
  viewItemList?: string;
  viewItemListId?: string;
  recipeName?: string;
  clickedFrom?: string;
  currentProductID?: string | number;
  isOpen?: boolean;
  datalayerTitle?: string;
  itemPosition?: number;
  displayedFrom?: string;
  onSubstitutionChange?: any;
}

const OfferCard: React.FC<OfferCardProps> = ({
  item,
  isSearchPage = false,
  isGlobalSearch = false,
  isShopped = false,
  showAddToCartButton = true,
  showFavoriteButton = true,
  query,
  checked,
  onCheckboxClick,
  className = "",
  checkBoxClass,
  listId = 0,
  onVisibilityChange,
  observerAffilation,
  pageId = "",
  viewItemList,
  viewItemListId,
  recipeName,
  clickedFrom,
  currentProductID,
  isOpen = false,
  datalayerTitle,
  itemPosition,
  displayedFrom,
  onSubstitutionChange,
}) => {
  const pathname = usePathname();
  const { loggedIn: userLoggedIn, uid: Uid } = useAppSelector(
    (state) => state.gigyaslice
  );
  console.log("clickedFrom", clickedFrom, "isOpen", isOpen);
  const { itemsList }: any = useAppSelector((state) => state?.manageListSlice);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const dispatch = useAppDispatch();
  const managementListData: any = useAppSelector(
    (state) => state?.manageListSlice
  );
  const imageURL = CheckValidProductImage(item?.images);
  const globalSearch = useAppSelector((state) => state.algoliaSlice.search);
  const [isChecked, setIsChecked] = useState(checked);

  const [isItemFavourite, setIsItemFavourite] = useState(false);
  const [productToBeAdded, setProductToBeAdded] = useState({});

  const shoppingList: any = useAppSelector((state) => state?.shoppingListSlice);

  const shoppingListName: any = useAppSelector(
    (state) => state?.shoppingListSlice?.listName
  );
  const favouriteList: any = useAppSelector(
    (state) => state?.favouriteProductSlice
  );
  const [productImageSrc, setProductImageSrc] = useState<string>(
    imageURL ? imageURL : "/grocerry.svg"
  );
  const searchDropdown = useAppSelector((state) => state.aemStaticSearchData);

  const gigyaToken = useGigyaAccountInfo();

  const [quantity, setQuantity] = useState(0);
  const [isFavourite, setIsFavourite] = useState(false);
  const [productQty, setProductQty] = useState(0);
  const [isProductQtyClick, setIsProductQtyClick] = useState(false);
  const router = useRouter();
  const [isListToast, setIsListToast] = useState(false);
  const [isFavouriteToast, setIsFavouriteToast] = useState({
    status: false,
    isAdded: false,
  });
  const [incrementDisable, setincrementDisable] = useState(false);
  const [decrementDisable, setdecrementDisable] = useState(false);
  const [articleId, setArticleId] = useState("");
  const [lastRecipeName, setlastRecipeName] = useState("");

  const { gigya } = useGigya();

  const [productLimitToast, setProductLimitToast] = useState(false);
  const [isItemUnFavourite, setIsItemUnFavourite] = useState("");
  const store = localStorage.getItem("store");
  const storeID =
    (store && JSON.parse(store)?.storeNumber) ||
    process.env.NEXT_PUBLIC_DEFAULT_STORE_NUMBER;
  const [clickCount, setClickCount] = useState(0);
  const timerRef = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    const prefilledQuantity =
      shoppingList?.shoppingListProducts?.products?.find(
        (product: ShoppingListItem) => product?.item_id == item?.objectID
      );

    if (prefilledQuantity) {
      setQuantity(prefilledQuantity?.quantity);
      const jsonrecipeName =
        prefilledQuantity.meta && JSON.parse(prefilledQuantity.meta).recipeName;
      let recipename = jsonrecipeName?.length > 0 ? jsonrecipeName.at(-1) : "";
      if (recipename && recipename.length > 20) {
        recipename = recipename.substring(0, 20) + "...";
      }
      setlastRecipeName(recipename);
    } else {
      setQuantity(0);
    }
    if (favouriteList?.favouriteProducts?.products.length > 0) {
      const prefilledFavourite =
        favouriteList?.favouriteProducts?.products.find(
          (favouriteItem: ShoppingListItem) =>
            favouriteItem?.item_id == item?.objectID
        );
      if (prefilledFavourite) {
        setIsFavourite(true);
      }
    }
    if (imageURL) {
      setProductImageSrc(imageURL);
    }
  }, [
    favouriteList,
    shoppingList?.shoppingListProducts?.products,
    item?.objectID,
    storeID,
  ]);

  const cardClickHandler = () => {
    // algolia click event
    itemClickAnalytics();
    if (globalSearch?.queryValue?.length && item?.__queryID?.length) {
      analyticsClickEventAfterSearch({
        kind: "products",
        index: algoliaConfig.indexNames.products,
        objectIDs: [String(item.objectID)],
        userToken: Uid ?? undefined,
        positions: [item.__position!],
        queryID: String(item.__queryID),
      });
    } else {
      analyticsClickEventBeforeSearch({
        kind: "products",
        index: algoliaConfig.indexNames.products,
        objectIDs: [String(item.objectID)],
        userToken: Uid ?? undefined,
      });
    }
  };

  const checkboxHandler = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setIsChecked(!isChecked);
    if (onCheckboxClick) {
      onCheckboxClick(e);
    }
  };

  const [shopPopUp, setShowPopUp] = useState(false);
  const [promotionsItemsData, setPromotionsItemsData] = useState<any>([]);
  const [productPromotions, setProductPromotions] = useState<any>([]);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      if (searchDropdown?.dropdown?.hidePromotions) return;
      if (
        showPromotions(
          searchDropdown?.dropdown?.hideallpromotions ?? [],
          storeID
        )
      )
        return;
      const data = await promotionMapping([item]);
      const key = data?.[0]?.offerType
        ? PromotionKeys[data[0].offerType as TPromotionKeys]
        : undefined;
      const dropdownValue =
        key && searchDropdown?.dropdown
          ? searchDropdown.dropdown[key as keyof typeof searchDropdown.dropdown]
          : undefined;
      if (data != undefined) {
        if (
          item?.hidePromotions ||
          showPromotions((dropdownValue as string[]) ?? [], storeID)
        )
          setPromotionsItemsData([]);
        else {
          setPromotionsItemsData(data);
        }
      } else {
        setPromotionsItemsData([]);
      }

      return data;
    } catch (error) {
      // console.error(error, "Error fetching promotions data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [item]);

  const addToListHandler = (quantity: number, item: Product) => {
    // setAnimationLoading(true)
    setQuantity(quantity);
    // algolia add to list event
    if (!userLoggedIn && managementListData?.itemsList?.length == 0) {
      setShowPopUp(true);
    } else if (
      globalSearch?.queryValue?.length &&
      globalSearch.queryID?.products?.length
    ) {
      analyticsAddToCartEventAfterSearch({
        objectIDs: [String(item.objectID)],
        userToken: Uid ?? undefined,
        queryID: globalSearch.queryID.products,
        quantity,
      });
    } else {
      analyticsAddToCartEventBeforeSearch({
        objectIDs: [String(item.objectID)],
        userToken: Uid ?? undefined,
        quantity,
      });
    }
  };

  const removeFromCartAnalytics = (item: Product | any) => {
    const promotionValues = item?.promotions && Object.values(item.promotions);
    const hasPromotionReward = promotionValues?.[0]?.promotionReward;
    const includesY =
      hasPromotionReward?.[0]?.membershipLevelText?.includes("Y");

    let offerTag = "";
    if (promotionValues !== undefined) {
      if (includesY) {
        offerTag = "Mass offer - Scene+";
      } else if (hasPromotionReward) {
        offerTag = "Mass offer - Non Scene+";
      }
    }
    const manageList = managementListData?.itemsList?.filter(
      (item: { is_active: number }) => item.is_active === 1
    );
    dataLayerRemoveFormList({
      event: "remove_product_from_list",
      product_name: item.name,
      item_list_name:
        shoppingListName != ""
          ? shoppingListName
          : userLoggedIn
            ? manageList?.[0]?.name
            : managementListData?.itemsList?.[0]?.name,
      page_title: document.title,
      offer_tag: offerTag ?? "",
    });
    sendSalesforceInteraction({
      name: "cartItem",
      banner: process.env.NEXT_PUBLIC_MERCHANT_IDENTIFIER,
      cartItemStatus: "Remove Item from List",
      currency: "$",
      price: item.price ?? 0,
      quantity: 0,
      catalogObjectId: `${item?.articleNumber}`,
      catalogObjectType: item?.name ?? "",
      isAnonymous: Uid ? 0 : 1,
      gigyaUid: Uid,
      cartEventId: "",
      screenName: document.title,
      screenClass: window.location.href,
      utmSource: getUTMParameter("utm_source"),
      utmMedium: getUTMParameter("utm_medium"),
      utmCampaign: getUTMParameter("utm_campaign"),
    });
  };
  const addToCartAnalytics = (item: Product | any, quantity: number) => {
    const promotionValues = item?.promotions && Object.values(item.promotions);
    const hasPromotionReward = promotionValues?.[0]?.promotionReward;
    const includesY =
      hasPromotionReward?.[0]?.membershipLevelText?.includes("Y");

    let offerTag = "";
    if (promotionValues !== undefined) {
      if (includesY) {
        offerTag = "Mass offer - Scene+";
      } else if (hasPromotionReward) {
        offerTag = "Mass offer - Non Scene+";
      }
    }
    const manageList = managementListData?.itemsList?.filter(
      (item: { is_active: number }) => item.is_active === 1
    );

    addDataLayerProductToList({
      event: item?.allergens?.alcohol
        ? "add_liquor_product_to_list"
        : "add_products_to_list",
      product_name: item.name,
      list_name:
        pathname == "/products"
          ? "All Products"
          : datalayerTitle
            ? datalayerTitle
            : (item?.hierarchicalCategories?.lvl0?.[0] ?? ""),
      item_list_name:
        shoppingListName != ""
          ? shoppingListName
          : userLoggedIn
            ? manageList?.[0]?.name
            : managementListData?.itemsList?.[0]?.name,

      page_title: document.title,
      offer_tag: offerTag,
    });
    sendSalesforceInteraction({
      name: "cartItem",
      banner: process.env.NEXT_PUBLIC_MERCHANT_IDENTIFIER,
      cartItemStatus: "Add Item to List",
      currency: "$",
      price: item?.price ?? 0,
      quantity: quantity,
      catalogObjectId: `${item?.articleNumber}`,
      catalogObjectType: item?.name ?? "",
      isAnonymous: Uid ? 0 : 1,
      gigyaUid: Uid,
      cartEventId: "",
      screenName: document.title,
      screenClass: window.location.href,
      utmSource: getUTMParameter("utm_source"),
      utmMedium: getUTMParameter("utm_medium"),
      utmCampaign: getUTMParameter("utm_campaign"),
    });
  };
  const checkLimitForToast = (isToast: boolean) => {
    setProductLimitToast(isToast);
  };
  const addToCart = useCallback(
    async (product_quantity: number) => {
      try {
        checkLimitForToast(false);
        const prefilledQuantity =
          shoppingList?.shoppingListProducts?.products?.find(
            (product: ShoppingListItem) => product?.item_id == item?.objectID
          );
        setIsListToast(false);
        const updatedQuantity = product_quantity === -1 ? 0 : product_quantity;
        if (
          updatedQuantity === 0 ||
          prefilledQuantity?.quantity > updatedQuantity
        ) {
          removeFromCartAnalytics(item);
        } else {
          addToCartAnalytics(item, updatedQuantity);
        }
        const isShoppedCurrentValue = shoppingList?.shoppingListProducts
          ? shoppingList?.shoppingListProducts?.products?.find(
            (product: { item_id: string | number }) =>
              product?.item_id == item.objectID
          )?.is_shopped
          : 0;

        const recipeNameObj = {
          recipeName: [recipeName],
        };
        const data = {
          item_id: `${item?.objectID}`,
          listType: "Product",
          quantity: updatedQuantity,
          is_favourite: 0,
          is_shopped: isShoppedCurrentValue ?? 0,
          userId: userLoggedIn ? Uid : "",
          createdAt: new Date(),
          meta:
            recipeName && recipeName != ""
              ? JSON.stringify(recipeNameObj)
              : prefilledQuantity?.meta,
          storeId: storeID,
        };
        const dataaction = {
          itemId: `${item?.objectID}`,
          listType: "Product",
          quantity: updatedQuantity,
          isFavourite: 0,
          isShopped: isShoppedCurrentValue ?? 0,
          userId: userLoggedIn ? Uid : "",
          categoryId: listId,
          insertId: "",
          name: "",
          deletedId: "",
          listName: listId != 0 ? shoppingListName : "",
          userToken: "",
          meta:
            recipeName && recipeName != "" ? JSON.stringify(recipeName) : "",
          storeId: storeID,
        };
        if (userLoggedIn) {
          const userResponse = await gigyaToken();
          if (userResponse.idToken != "") {
            dataaction.userToken = userResponse.idToken;
            const result = await dispatch(addListItemsToCart(dataaction));
            if (result && result.type == "add_list_to_cart/fulfilled") {
              const activeList = managementListData?.itemsList?.filter(
                (item: { is_active: number }) => item.is_active === 1
              );
              dataaction.insertId = result?.payload?.resultData?.id;
              dataaction.categoryId =
                result?.payload?.resultData?.category_id ?? activeList?.[0]?.id;
              dataaction.name =
                result?.payload?.resultData?.listName ?? activeList?.[0]?.name;
              dataaction.deletedId = result?.payload?.deletedId;
              if (listId == 0) {
                dispatch(updateCartShoppingList(dataaction));
              } else if (
                listId != 0 &&
                result?.payload?.listInfo?.id == listId &&
                result?.payload?.listInfo?.is_active == 1
              ) {
                dispatch(updateCartShoppingList(dataaction));
              }
              if (
                listId != 0 &&
                shoppingListName == "Favourites" &&
                shoppingList?.shoppingListProducts?.products.length == 1 &&
                product_quantity == -1 &&
                result?.payload?.deletedId != ""
              ) {
                router.push("/manage-list");
              }
            } else {
              setQuantity(product_quantity === -1 ? 0 : -1);
            }
          } else {
            setQuantity(product_quantity === -1 ? 0 : -1);
          }
        } else {
          if (
            shoppingList?.shoppingListProducts?.products &&
            shoppingList?.shoppingListProducts?.products.length >= 100 &&
            !prefilledQuantity
          ) {
            checkLimitForToast(true);
            setQuantity(product_quantity === -1 ? 0 : -1);
          } else {
            checkLimitForToast(false);
            dispatch(setItemListData(data));
            dispatch(setCartItemListData(data));
          }
        }
        // Add product using the helper
        addOrUpdateProductAndRefreshExisting(item);
        setIsProductQtyClick(false);
      } catch (err: any) {
        console.log("error", err);
      } finally {
        setdecrementDisable(false);
        setincrementDisable(false);
        setArticleId("");
      }
    },
    [
      item,
      userLoggedIn,
      shoppingList?.shoppingListProducts?.products,
      setQuantity,
      storeID,
    ]
  );
  const debouncedQuery = useDelayedCallback(productQty, 500);

  useEffect(() => {
    if (isProductQtyClick) {
      addToCart(debouncedQuery);
    }
  }, [debouncedQuery]);

  const [loginModalOpen, setloginModalOpen] = useState(false);
  const [showQuantityText, setShowQuantityText] = useState(false);

  const lastFocusedElement = useRef<HTMLElement | null>(null);
  const handleLoginModal = () => {
    if (!loginModalOpen) {
      lastFocusedElement.current = document.activeElement as HTMLElement;
    }
    setloginModalOpen((prev) => !prev);
    setShowQuantityText(false);
  };

  useEffect(() => {
    if (!loginModalOpen && lastFocusedElement.current) {
      lastFocusedElement.current.focus();
    }
  }, [loginModalOpen]);

  const handleFavouriteList = async (
    favouiteStatus: boolean,
    itemInfo: Product
  ) => {
    try {
      setIsFavouriteToast({ status: false, isAdded: false });
      const favrourite = favouiteStatus ? 1 : 0;
      if (favrourite == 1) {
        addToFavouriteAnalytics(itemInfo);
      }
      // check for store. will use later
      // const prefilledFavourite =
      // favouriteList?.favouriteProducts?.products.find(
      //   (favouriteItem: ShoppingListItem) =>
      //     favouriteItem?.item_id == item?.objectID
      // );

      // const result = await fetchAlgoliaProduct(
      //   favouriteList?.favouriteProducts?.products, storeID,storeRegion
      //   );
      //   const objectIDs = new Set(result?.map((p: { objectID: string; }) => p?.objectID));

      //   const count = favouriteList?.favouriteProducts?.products?.reduce((sum: number, item: { item_id: string; quantity: number; }) => {
      //     return objectIDs.has(item?.item_id) ? sum + item?.quantity : sum;
      //   }, 0);

      if (userLoggedIn && Uid && Uid != "") {
        // check for store. will use later
        // if(count >= 100 && !prefilledFavourite && favrourite == 1) {
        //   setIsFavouriteToast({ status: true, isAdded: favrourite == 1 });
        //   setIsItemFavourite(!favouiteStatus)
        //   setIsFavourite(!favrourite)
        //   setIsItemUnFavourite(item?.objectID)
        //   return
        // }else {
        setIsFavouriteToast({ status: false, isAdded: false });

        const data = {
          item_id: `${itemInfo?.objectID}`,
          is_favourite: favrourite,
          userToken: "",
          storeId: storeID,
        };
        const userResponse = await gigyaToken();
        if (userResponse.idToken) {
          data.userToken = userResponse.idToken;
          const result = await dispatch(addItemToFavouriteList(data));
          console.log("shoppingListName", shoppingListName);
          if (result.type == "add_shopping_list_favourrite/fulfilled") {
            if (listId != 0 && shoppingListName == "Favourites") {
              dispatch(deleteFavouriteProduct(itemInfo?.objectID));
              if (
                shoppingList?.shoppingListProducts?.products.length == 1 &&
                result?.type == "add_shopping_list_favourrite/fulfilled"
              ) {
                router.push("/manage-list");
              }
            }
            setIsItemFavourite(favouiteStatus);
            setIsFavouriteToast({ status: true, isAdded: favrourite == 1 });
            setIsFavourite(favrourite == 1);
            setIsItemUnFavourite("");

            if (favrourite == 0) {
              setIsItemUnFavourite("");
              setIsFavourite(false);
              setIsItemFavourite(false);
            }
          } else {
            setIsItemFavourite(!favouiteStatus);
            setIsFavourite(!favrourite);
            setIsItemUnFavourite(item?.objectID);
            setIsFavouriteToast({ status: false, isAdded: false });
          }
        }
        // }
      } else {
        setShowPopUp(false);
        setIsItemFavourite(favouiteStatus);
      }
    } catch (err: any) {
      console.log("error", err);
    } finally {
      setTimeout(() => {
        dispatch(setFavouriteMessage());
        dispatch(setShoppingMessage());
      }, 1000);
    }
  };

  const addToFavouriteAnalytics = (item: Product) => {
    addDataLayerProductToFavourite({
      event: "add_to_favorite",
      product_name: item.name,
      list_name: item?.hierarchicalCategories?.lvl0?.[0],
      item_list_name: "Favourites",
      page_title: document.title,
      item: "Product",
    });
  };
  const fetchPromotions = async (productIds: any) => {
    const itemsQuery = productIds
      .map((id: string) => `articleNumber:${id}`)
      .join(" OR ");
    try {
      const productData = await searchBySingleIndex({
        indexName: ALGOLIA_INDEXES.PRODUCTS.PRIMARY_INDEX,
        searchParams: {
          filters: `(${itemsQuery}) AND storeId:"${storeID}" AND isVisible:true AND isMassOffers:false`,
        },
      });
      const products = productData?.hits;
      return products;
    } catch (err: any) {
      console.log("error:", err);
    }
  };

  const itemClickAnalytics = () => {
    const itemInfo = {
      item_id: item?.articleNumber ?? "",
      item_name: item?.name ?? "",
      affiliation: viewItemListId ? "product" : "Mass Offers",
      coupon: "",
      discount: item?.promotions?.[0]?.promotionDescription,
      index: item.__position! ?? itemPosition,
      item_category: item?.hierarchicalCategories?.lvl0?.[0] ?? "",
      location_id: item?.storeId,
      item_list_id: viewItemListId ?? "4",
      item_list_name: viewItemList ?? "Mass Offers",
      price: item?.price,
      page_id: `${pageId}`,
    };
    dataLayerProductSelectList({
      event: "select_item",
      ecommerce: {
        item_list_id: viewItemListId ?? "4",
        item_list_name: viewItemList ?? "Mass Offers",
        items: [itemInfo],
      },
    });
  };

  const itemRef = useRef<HTMLDivElement | null>(null); // Ref for the item element

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Notify the parent component about the visibility change
        const categoryName = item?.hierarchicalCategories?.lvl0?.[0] ?? "";
        const itemdiscount = item?.promotions?.[0]?.promotionDescription;
        const filteredProduct = (({ articleNumber, name, price, storeId }) => ({
          item_id: articleNumber,
          item_name: name,
          item_category: categoryName,
          affiliation: observerAffilation ?? "product",
          coupon: "",
          discount: itemdiscount ?? "",
          index: item.__position! ?? itemPosition,
          location_id: storeId,
          price,
          item_list_id: viewItemListId ?? "",
          item_list_name: viewItemList ?? "",
          page_id: `${pageId}`,
        }))(item);

        if (onVisibilityChange) {
          onVisibilityChange(filteredProduct, entry.isIntersecting);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
      }
    );
    if (itemRef.current) {
      observer.observe(itemRef.current);
    }
    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, []);

  const handleListResponse = () => {
    setIsListToast(true);
  };

  function handleClose(): void {
    console.log("Close message.");
  }

  const { substituteListData } = useAppSelector(
    (state) => state?.shoppingListSlice
  );
  const matchedSubstitute = substituteListData?.find(
    (entry: any) =>
      entry.substituteProductID === item?.objectID &&
      entry.currentProductID === currentProductID
  );

  const similarItem = substituteListData?.find(
    (entry: any) =>
      entry.substituteProductID === item?.objectID &&
      entry.currentProductID !== currentProductID
  );
  const handleSubtituteProduct = () => {
    const data = {
      currentProductID: currentProductID,
      substituteProductID: item?.objectID,
    };

    dispatch(setSubstituteListData(data));
  };

  const recipeNameValue = shoppingList?.shoppingListProducts?.products.find(
    (shopItem: any) => shopItem.item_id === item.objectID
  );

  let recipeMetaName = "";

  try {
    const parsedMeta = JSON.parse(recipeNameValue?.meta || "[]");
    recipeMetaName = parsedMeta.recipeName?.[0] || "";
  } catch (e) {
    console.error("Failed to parse meta", e);
  }

  return (
    <>
      {isListToast && (
        <CustomToast
          message={
            <Box as="div" className="text-body">
              {"List created."}
            </Box>
          }
          bgColor={"success"}
          position="top"
          onClose={handleClose}
          autoCloseDuration={1000}
          closeButton={
            <Text as="span" className="demo-icon icon-close text-body"></Text>
          }
          className="font-normal flex z-[9999] min-w-[150px] !w-auto"
        />
      )}

      {
        // listId == 0 &&
        !favouriteList?.isLoading &&
        !favouriteList?.isError &&
        favouriteList?.message != "" && (
          <CustomToast
            message={
              <Box as="div" className="text-[14px]">
                {favouriteList.message}
              </Box>
            }
            bgColor={`success`}
            position="top"
            onClose={handleClose}
            autoCloseDuration={1000}
            closeButton={
              <Text
                as="span"
                className="demo-icon icon-close text-[14px]"
              ></Text>
            }
            className="font-normal flex z-[9999] min-w-[285px] !w-auto"
          />
        )
      }

      {(shoppingList?.isError && shoppingList?.errorMessage?.[0]?.message) ||
        productLimitToast ? (
        <CustomToast
          message={
            <Box as="div" className="text-body">
              {productLimitToast &&
                !shoppingList?.isError &&
                `Maximum limit is 100 for a list.`}
              {shoppingList?.errorMessage?.[0]?.message}
            </Box>
          }
          bgColor={"error"}
          position="top"
          onClose={handleClose}
          autoCloseDuration={1000}
          closeButton={
            <Text as="span" className="demo-icon icon-close text-body"></Text>
          }
          className="font-normal flex z-[9999] w-[90%] md:w-[600px] lg:w-auto"
        />
      ) : null}

      {favouriteList?.isError && favouriteList?.errorMessage?.[0]?.message ? (
        <CustomToast
          message={
            <Box as="div" className="text-body">
              {favouriteList?.errorMessage?.[0]?.message}
            </Box>
          }
          bgColor={"error"}
          position="top"
          onClose={handleClose}
          autoCloseDuration={1000}
          closeButton={
            <Text as="span" className="demo-icon icon-close text-body"></Text>
          }
          className="font-normal flex z-[9999] w-[90%] md:w-[600px] lg:w-auto"
        />
      ) : null}

      <Box
        as="div"
        onClick={cardClickHandler}
        className={`${className} mt-0 flex flex-col w-full h-full max-h-[370px] relative [&>div.inline-block]:absolute [&>div.inline-block]:inset-0 [&>div.inline-block]:z-[9]
            ${(pathname.includes("/offers") && !isGlobalSearch && promotionsItemsData?.length === 0) || (isOpen && promotionsItemsData?.length === 0) ? "hidden" : ""}`}
        // className={`${className} mt-0 flex flex-col w-full h-full max-h-[370px] relative [&>div.inline-block]:absolute [&>div.inline-block]:inset-0 [&>div.inline-block]:z-[9]`}
        data-id={item?.articleNumber}
        ref={itemRef}
        id={"ObjectID-" + promotionsItemsData?.[0]?.objectID + " OfferType-" + promotionsItemsData?.[0]?.offerType}
      >
        <Link
          href={`/products/${encodeURIComponent(item.pageSlug?.replace(/\./g, "%2E"))}`}
          className="absolute inset-0 z-[1] tab rounded-xl"
          tabIndex={0}
          title={item?.name?.length > 45 && item?.name}
          aria-label={`Click here to go to ${item?.name} product detail page`}
        ></Link>
        <Box className="rounded-xl relative overflow-hidden shadow-[0_0_4px_0_rgba(0,0,0,0.25)] h-full">
          <Box as="div" className="relative h-[192px] pointer-events-none">
            <PromotionsHeader
              productData={promotionsItemsData}
              CardArticalId={item?.articleNumber}
              cardClassName="w-full rounded-t-xl rounded-b-none absolute top-0 left-0 mr-0"
              expClassName="absolute top-9 !pl-0 left-2 z-[1]"
            />

            <Box as="div" className={`relative px-4 py-[22px] h-[160px] top-8`}>
              <Box
                as="div"
                className="absolute pt-3 top-0 bottom-0 right-0 left-0 px-2 items-end flex gap-2 flex-col justify-between h-full z-[1] "
              >
                {isShopped && (
                  <>
                    <Checkbox
                      type="checkbox"
                      id={`checkbox-${item.objectID}`}
                      checked={isChecked}
                      onClick={checkboxHandler}
                      className={`absolute top-[25px] left-4 pointer-events-auto ${checkBoxClass} ${checkBoxClass === "checkTrue" ? "before:bg-neutral-900 after:border-l-2 after:border-b-2  after:w-[10px]" : ""}`}
                    />
                    <label
                      htmlFor={`checkbox-${item.objectID}`}
                      className="sr-only"
                    >
                      Select item {item.objectID}
                    </label>
                  </>
                )}

                {showFavoriteButton && (
                  <FavoriteButton
                    disabled={favouriteList.isLoading}
                    unFavourite={isItemUnFavourite}
                    className="pointer-events-auto"
                    isUserLoggedOut={!userLoggedIn}
                    onFavoriteToggle={async () => {
                      if (!userLoggedIn) {
                        handleLoginModal();
                        return;
                      }
                      await handleFavouriteList(
                        isFavourite ? !isFavourite : !isItemFavourite,
                        item
                      );
                    }}
                    itemDetail={item}
                    favouriteStatus={isFavourite}
                  />
                )}
                {clickedFrom == "productpage" ? (
                  <Button
                    onClick={handleSubtituteProduct}
                    className="pointer-events-auto"
                    disabled={similarItem ? true : false}
                  >
                    <Text
                      as="span"
                      className={`icon icon-check text-[12px] mr-[10px] ${matchedSubstitute ? "" : "hidden"} `}
                    ></Text>
                    Substitute
                  </Button>
                ) : (
                  showAddToCartButton && (
                    <AnimatedQuantityButton
                      // disabledDelete={shoppingListName == "Favourites"}
                      disabled={
                        (shoppingList.isLoading &&
                          articleId != item?.articleNumber) ||
                          !item?.inStock
                          ? true
                          : false
                      }
                      className={`pointer-events-auto ${item?.inStock ? "" : "!opacity-100 [&>button]:!text-grey550 [&>button>div]:!text-grey550 [&>button]:!bg-neutral100 [&>button]:!border-neutral100 [&>button]:!pointer-events-none !cursor-not-allowed !pointer-events-auto"}`}
                      shopPopUp={
                        managementListData?.itemsList?.length == 0 ||
                        (managementListData?.itemsList?.length == 1 &&
                          favouriteList?.listName == "Favourites" &&
                          listId == 0)
                      }
                      productQuantity={quantity ?? 0}
                      clickCallbackHandler={(newquantity: number) => {
                        setClickCount((prev) => prev + 1);
                        checkLimitForToast(false);
                        if (newquantity > quantity) {
                          setdecrementDisable(true);
                        } else {
                          setincrementDisable(true);
                        }

                        if (
                          managementListData?.itemsList?.length == 0 ||
                          (managementListData?.itemsList?.length == 1 &&
                            favouriteList?.listName == "Favourites" &&
                            listId == 0)
                        ) {
                          setProductToBeAdded({
                            item_id: `${item?.objectID}`,
                            listType: "Product",
                            quantity: 1,
                            is_favourite: 0,
                            is_shopped: 0,
                            userId: Uid ?? "",
                            createdAt: new Date(),
                            storeId: storeID,
                          });
                          setincrementDisable(false);
                          handleLoginModal();
                          setShowQuantityText(true);
                          return;
                        }
                        if (!loginModalOpen) {
                          // setProductQty(newquantity == 0 ? -1 : newquantity);
                          if (timerRef.current) {
                            clearTimeout(timerRef.current);
                          }
                          timerRef.current = setTimeout(() => {
                            if (
                              clickCount == 0 ||
                              clickCount == 1 ||
                              !userLoggedIn
                            ) {
                              addToCart(newquantity == 0 ? -1 : newquantity);
                            } else {
                              setProductQty(
                                newquantity == 0 ? -1 : newquantity
                              );
                            }
                            setClickCount(0);
                          }, 200);
                          setArticleId(item?.articleNumber);
                          setIsProductQtyClick(true);
                          addToListHandler(newquantity, item);
                        }
                      }}
                      isIncrementDisabled={incrementDisable}
                      isDecrementDisabled={decrementDisable}
                      isUserLoggedOut={true}
                      // animationLoading={animationLoading}
                      defaultFullView={false}
                    />
                  )
                )}
              </Box>
              <Box
                as="div"
                className={`relative m-auto max-w-[182px] w-full h-[148px]`}
              >
                 {imageURL ? (
                    <Box
                      as="div"
                      className={`absolute bottom-[5px] left-0 right-0`}
                    >
                      <ImageWrapper
                        src={productImageSrc}
                        className={`object-contain w-full h-[130px] mx-auto ${item?.productImgClass}`}
                        alt={item?.name ?? "product image"}
                        width={182}
                        height={182}
                        onError={() => {
                          setProductImageSrc("/grocerry.svg");
                        }}
                      />
                    </Box>
                  ) : (
                    <Box
                      as="div"
                      className="flex flex-col items-center justify-center h-full relative top-[-14px]"
                    >
                      <ImageWrapper
                        src={`/grocerry.svg`}
                        className={`object-contain w-full h-[130px] mx-auto object-bottom`}
                        alt={"Dummy image"}
                        width={182}
                        height={148}
                      />
                    </Box>
                  )}
              </Box>
              <OfferCardBadge promotions={promotionsItemsData} />
            </Box>
          </Box>

          <Box as="div" className="p-4">
            <Box as="div" className="flex flex-col gap-2">
              <Box as="div" className="flex flex-col gap-1">
                <Text as="p" className="flex gap-1 items-center flex-wrap">
                  {promotionsItemsData && promotionsItemsData?.length > 0 ? (
                    <>
                      {(promotionsItemsData?.[0]?.offerIdentifier ===
                        "No Min Condition" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "No Min Condition with Multi Promo" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "Multi Reward" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "multi promo type 1" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "Multi promo only VKAO" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "3 Promotions" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "multi promo type 2") &&
                        promotionsItemsData?.[0]?.salePrice <
                        promotionsItemsData?.[0]?.price && (
                          <Text
                            as="span"
                            className="text-red200 font-bold text-body"
                          >
                            ${promotionsItemsData?.[0]?.salePrice?.toFixed(2)}
                            {item?.uom === "KG" ? "/kg" : ""}
                          </Text>
                        )}
                      <Text
                        as="span"
                        className={`font-bold text-body ${(promotionsItemsData?.[0]?.offerIdentifier ===
                          "No Min Condition" ||
                          promotionsItemsData?.[0]?.offerIdentifier ===
                          "No Min Condition with Multi Promo" ||
                          promotionsItemsData?.[0]?.offerIdentifier ===
                          "Multi Reward" ||
                          promotionsItemsData?.[0]?.offerIdentifier ===
                          "multi promo type 1" ||
                          promotionsItemsData?.[0]?.offerIdentifier ===
                          "Multi promo only VKAO" ||
                          promotionsItemsData?.[0]?.offerIdentifier ===
                          "3 Promotions" ||
                          promotionsItemsData?.[0]?.offerIdentifier ===
                          "multi promo type 2") &&
                          promotionsItemsData?.[0]?.salePrice <
                          promotionsItemsData?.[0]?.price
                          ? "line-through"
                          : ""
                          }`}
                      >
                        ${promotionsItemsData?.[0]?.price?.toFixed(2)}
                        {item?.uom === "KG" ? "/kg" : ""}
                      </Text>
                      {(promotionsItemsData?.[0]?.offerIdentifier ===
                        "No Min Condition" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "No Min Condition with Multi Promo" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "Multi Reward" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "multi promo type 1" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "Multi promo only VKAO" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "3 Promotions" ||
                        promotionsItemsData?.[0]?.offerIdentifier ===
                        "multi promo type 2") && (
                          <>
                            {promotionsItemsData?.[0]?.rewardType == 1 &&
                              promotionsItemsData?.[0]?.salePrice <
                              promotionsItemsData?.[0]?.price && (
                                <>
                                  <Text
                                    as="span"
                                    className="bg-yellow150 text-brandBlack inline-flex text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
                                  >
                                    SAVE
                                  </Text>
                                  <Text
                                    as="span"
                                    className="inline-flex font-bold text-body"
                                  >
                                    {promotionsItemsData?.[0]?.rewardValue && (
                                      <SplitAmount
                                        amount={(
                                          promotionsItemsData?.[0]?.rewardValue?.split(
                                            "."
                                          )[0] / 100
                                        )?.toString()}
                                      />
                                    )}
                                  </Text>
                                </>
                              )}
                            {promotionsItemsData?.[0]?.rewardType == 2 &&
                              promotionsItemsData?.[0]?.salePrice <
                              promotionsItemsData?.[0]?.price && (
                                <>
                                  <Text
                                    as="span"
                                    className="bg-yellow150 text-brandBlack inline-flex text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
                                  >
                                    SAVE
                                  </Text>
                                  <Text
                                    as="span"
                                    className="inline-flex font-bold text-body"
                                  >
                                    {promotionsItemsData?.[0]?.rewardValue && (
                                      <Text
                                        as="span"
                                        className="pt-[0px] mb-[0px] inline-flex font-bold text-body"
                                      >
                                        {
                                          promotionsItemsData?.[0]?.rewardValue
                                            ?.toString()
                                            ?.split(".")[0]
                                        }
                                        %
                                      </Text>
                                    )}
                                  </Text>
                                </>
                              )}
                            {/* {promotionsItemsData?.[0]?.rewardType == 3 &&
                                <>
                                  <Text
                                    as="span"
                                    className="bg-yellow150 text-brandBlack inline-flex text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
                                  >
                                    SAVE
                                  </Text>
                                  <Text
                                    as="span"
                                    className="inline-flex font-bold text-body"
                                  >
                                    {promotionsItemsData?.[0]?.rewardValue && (
                                      <Text
                                        as="span"
                                        className="pt-[0px] mb-[0px] inline-flex font-bold text-body"
                                      >
                                        {
                                          promotionsItemsData?.[0]?.rewardValue
                                            ?.toString()
                                            ?.split(".")[0]
                                        }
                                        %
                                      </Text>
                                    )}
                                  </Text>
                                </>
                              )}
                            {/* {promotionsItemsData?.[0]?.rewardType == 3 &&
                              promotionsItemsData?.[0]?.salePrice <
                                promotionsItemsData?.[0]?.price && (
                                <>
                                  <Text
                                    as="span"
                                    className="bg-yellow150 text-brandBlack inline-flex text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
                                  >
                                    SAVE
                                  </Text>
                                  <Text
                                    as="span"
                                    className="inline-flex font-bold text-body"
                                  >
                                    $
                                    {(
                                      promotionsItemsData?.[0]?.price -
                                      promotionsItemsData?.[0]?.salePrice
                                    ).toFixed(2)}
                                  </Text>
                                </>
                              )} */}
                          </>
                        )}
                    </>
                  ) : (
                    item?.price && (
                      <Text as="span" className="font-bold text-body">
                        ${item.price.toFixed(2)}
                        {item?.uom === "KG" ? "/kg" : ""}
                      </Text>
                    )
                  )}
                </Text>

                {searchDropdown?.dropdown?.showWeight && item?.weight && (
                  <Text as="p" className="text-sm">
                    {item?.weight}
                  </Text>
                )}
              </Box>
              {(item?.brand || item?.name) && (
                <Box as="div" className="flex flex-col gap-1">
                  {item?.brand && (
                    <Text as="p" className="text-sm font-bold capitalize">
                      {item?.brand}
                    </Text>
                  )}
                  {promotionsItemsData?.[0]?.offerIdentifier !==
                    "No Min Condition" &&
                    promotionsItemsData?.[0]?.offerIdentifier !==
                    "No Min Condition with Multi Promo" &&
                    promotionsItemsData?.[0]?.offerIdentifier !==
                    "Multi Reward" &&
                    promotionsItemsData?.[0]?.offerIdentifier !==
                    "multi promo type 1" &&
                    promotionsItemsData?.[0]?.offerIdentifier !==
                    "Multi promo only VKAO" &&
                    promotionsItemsData?.[0]?.offerIdentifier !==
                    "3 Promotions" &&
                    promotionsItemsData?.[0]?.promotionDescription ? (
                    <Box className="flex justify-start items-start">
                      {promotionsItemsData?.[0]?.memberType?.includes("Y") ||
                        (promotionsItemsData?.[0]?.offerIdentifier ==
                          "multi promo type 2" &&
                          promotionsItemsData?.[0]?.memberType?.includes("N")) ? (
                        <ImageWrapper
                          src="/home/scene-plus.svg"
                          width={16}
                          height={16}
                          className="mr-2 mt-[4px]"
                          alt="scene plus image"
                        />
                      ) : (
                        promotionsItemsData?.[0]?.promotionDescription && (
                          <span className="w-2 h-2 rounded-full bg-red-500 min-w-2 min-h-2 mr-2 mt-[6px]"></span>
                        )
                      )}
                      <Text
                        as="p"
                        className={`card-title text-[14px] z-[9] ${isOpen ? "font-bold text-brandSecondary underline [&>strong]:font-bold" : ""}`}
                      >
                        {promotionsItemsData?.[0]?.rewardArticalID.length > 1 &&
                          !isOpen ? (
                          <>
                            <button
                              onClick={async () => {
                                if (
                                  promotionsItemsData?.[0]?.rewardArticalID
                                    .length > 1
                                ) {
                                  const data = await fetchPromotions(
                                    promotionsItemsData?.[0]?.rewardArticalID
                                  );
                                  setProductPromotions(data);
                                  setIsPanelOpen(true);
                                }
                              }}
                              className="!pb-0 !px-0  !pt-1 text-left gap-[2px] font-normal text-body !rounded-none underline text-brandBlack"
                            >
                              {promotionsItemsData?.[0]?.promotionDescription}
                            </button>
                          </>
                        )
                          :
                          promotionsItemsData?.[0]?.promotionDescription
                        }
                      </Text>
                    </Box>
                  ) : promotionsItemsData?.[0]?.offerIdentifier ===
                    "No Min Condition" &&
                    [1, 2, 3, 4, 5]?.includes(
                      promotionsItemsData?.[0]?.rewardType
                    ) ? (
                    <Text as="p" className="card-title text-[14px]">
                      <HighlightText
                        text={
                          truncateString(
                            promotionsItemsData?.[0]?.name,
                            38
                          ) ?? ""
                        }
                        highlightResult={item?._highlightResult}
                        attribute="name"
                        query={truncateString(query, 38) ?? ""}
                      />
                    </Text>
                  ) : (
                    <>
                      {item?.name && (
                        // <Text as="p" className="card-title text-[14px]">
                        <Text
                          as="p"
                          className={`${(lastRecipeName && listId != 0) ? "line-clamp-1" : ""} card-title text-[14px]`}
                        >
                          <HighlightText
                            text={truncateString(item?.name, 38) ?? ""}
                            highlightResult={item?._highlightResult}
                            attribute="name"
                            query={truncateString(query, 38) ?? ""}
                          />
                        </Text>
                      )}
                    </>
                  )}
                </Box>
              )}
            </Box>
            {lastRecipeName && displayedFrom == "shoppingListPage" && (
              <Box as="div" className="flex items-center mt-1">
                <ImageWrapper
                  src={"/assets/manageList/recipename.svg"}
                  alt="Recipe Image"
                  height={18}
                  width={18}
                  className="mr-2"
                />
                <Text
                  as="p"
                  className="card-meta text-[14px] line-clamp-1 mb-0"
                >
                  {lastRecipeName}
                </Text>
              </Box>
            )}

            {/* {pathname?.includes("/manage-list") &&
                recipeName &&
                recipeName?.length > 0 && (
                  <Box as="div" className="flex flex-col gap-2">
                    <Text as="p" className="text-body">
                      <ImageWrapper
                        src="/assets/manageList/recipe-icon.svg"
                        alt={"Recipe Icon"}
                        width={18}
                        height={18}
                      />{" "}
                      {recipeName}
                    </Text>
                  </Box>
                )} */}
          </Box>
        </Box>
      </Box>
      {isPanelOpen && (
        <GroupOffers
          productPromotions={productPromotions}
          isPanelOpen={isPanelOpen}
          setIsPanelOpen={setIsPanelOpen}
          promotionsItemsData={promotionsItemsData}
        />
      )}
      {loginModalOpen && (
        <ProductLoginModal
          loginModalOpen={loginModalOpen}
          loginModalClose={handleLoginModal}
          showQuantityText={showQuantityText}
          productToBeAdded={productToBeAdded}
          onQuantityUpdate={() => setQuantity(1)}
          listStatus={handleListResponse}
          item={item}
          recipeName={recipeName}
          storeId={storeID}
        />
      )}
    </>
  );
};

function areEqual(prevProps: any, nextProps: any) {
  return prevProps.item?.articleNumber === nextProps.item?.articleNumber;
}
export default React.memo(OfferCard, areEqual);
